<template>
  <div class="wrapper">
    <Header class="black"></Header>

    <div class="main">
      <div class="slogan">
        <div class="h1">打造视频梦工厂</div>
        <div class="h2">懂视频·更懂你</div>
      </div>

      <div class="container">
        <div class="title">
          <span><a href="about.html">关于我们</a></span>
          <span class="active">服务流程</span>
          <span><a href="question.html">常见问题</a></span>
        </div>

        <div class="box">
          <div class="list clearfix">
            <dl>
              <dt><i>01</i></dt>
              <dd>
                <div class="h1">发布拍片需求</div>
                <div class="summary">填写需要制作的视频基本信息，包括视频类型、时长、项目预算等，提交需求后，客服会通过留下的联系方式与您联系。</div>
              </dd>
            </dl>

            <dl>
              <dt><i>02</i></dt>
              <dd>
                <div class="h1">沟通确认</div>
                <div class="summary">平台与用户线下联系，明确详细的制作需求。</div>
              </dd>
            </dl>

            <dl>
              <dt><i>03</i></dt>
              <dd>
                <div class="h1">签订合同</div>
                <div class="summary">根据与用户的沟通结果生成《项目概要》、《合同》，用户查看无异议后在趣编网上进行合同签署。</div>
              </dd>
            </dl>

            <dl>
              <dt><i>04</i></dt>
              <dd>
                <div class="h1">方案策划</div>
                <div class="summary">用户支付策划费用，策划人根据需求提供合适的策划案，用户查看无异议后在趣编网上进行确认。</div>
              </dd>
            </dl>

            <dl>
              <dt><i>05</i></dt>
              <dd>
                <div class="h1">拍摄制作</div>
                <div class="summary">用户支付拍摄费用，制作团队根据策划案拍摄制作，用户查看无异议后在趣编网上进行确认。在确认过程中，用户可以对视频提出三次修改要求，制作团队会根据用户需求进行相应的修改。</div>
              </dd>
            </dl>

            <dl>
              <dt><i>06</i></dt>
              <dd>
                <div class="h1">确认下载视频</div>
                <div class="summary">视频确认无异议后，用户支付项目尾款。支付成功后用户可以下载该视频，此项目完成。</div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import '@/assets/js/common'
  import Header from  '@/components/Header'
  import Footer from  '@/components/Footer'
  import player from "@/components/Player";

  export default {
    components:{
      Header,
      Footer,
      player
    },
    data(){
      return{
        video:{
          src: 'https://qvbian-app.oss-cn-hangzhou.aliyuncs.com/index/cases/n1523843461419b.mp4',
          poster: 'https://static.qvbian.com/avator/201801/k1516004391410F.jpg'
        }
      }
    },
    mounted(){
    },
    methods:{

    }
  }
</script>

<style scoped>
  .main{ padding: 0 0 219px;}

  .slogan{ margin-bottom: 30px; padding-top: 33px; height: 200px; text-align: center; color: #ffffff; background: url("../../assets/images/about_slogan.png") no-repeat scroll center;}
  .slogan .h1{ font-size: 54px;}
  .slogan .h2{ margin-top: 13px; font-size: 24px; letter-spacing: 4px;}

  .title{text-align: center; background: #FFFFFF; border-radius: 2px;}
  .title span{ position: relative; display: inline-block; margin-right: 108px; width: 100px; line-height: 60px; font-size: 16px; color: #424753; opacity: 0.6;}
  .title span.active{ opacity: 1; font-weight: bold;}
  .title span.active:before{ content: ""; position: absolute; display: inline-block; bottom: 0; left: 35px; width: 30px; height: 0; border-bottom: #424753 solid 3px;}
  .title span:last-child{ margin-right: 0;}
  .title span a{ color: #424753;}

  .list dl{ float: left; margin-top: 30px; margin-left: 30px; padding: 24px 71px 0 45px; width: 380px; height: 280px; background: #ffffff;}
  .list dl:nth-child(3n+1){ margin-left: 0px;}
  .list dl dt i{ position: relative; display: block; width: 37px; height: 37px; line-height: 37px; font-size: 14px; text-align: center; color: #3E87FF; border: 1px solid #DDDDDD; border-radius: 2px; font-style: normal;}
  .list dl dt i:before{ content: ""; position: absolute; bottom: 0; left: 11px; display: block; width: 15px; height: 0; border-bottom: 2px solid #3E87FF;}
  .list dl dd{ margin-top: 38px; font-size: 14px; color: #424753;}
  .list dl dd .h1{ margin-top: 38px; font-size: 14px; color: #424753; font-weight: 600;}
  .list dl dd .summary{ margin-top: 12px; font-size: 12px; color: #424753; line-height: 20px; }
</style>



// WEBPACK FOOTER //
// App.vue?5a18814e